import React, { useEffect, useState } from "react";
import { GOOGLE_MAPS_API_KEY } from "lib/constants";
import PlaceholderAddressDropdown from "components/PlaceholderAddressDropdown";
import LocationIcon from "components/icons/location";
import PropTypes from "prop-types";
import { withTheme } from "styled-components";

export const MAPS_API_SRC = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=places,maps`;

export function loadMapsAPI(loadCallback, errorCallback) {
  if (!window?.google?.maps) {
    let script = document.querySelector(`script[src="${MAPS_API_SRC}"]`);
    if (!script) {
      script = document.createElement("script");
      script.src = MAPS_API_SRC;
      document.body.appendChild(script);
    }
    script.addEventListener("load", loadCallback);
    script.addEventListener("error", errorCallback);
  } else {
    loadCallback();
  }
}

const MapsAPIWrapper = ({ theme, children }) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (window?.google?.maps) {
      setHasLoaded(true);
    } else {
      loadMapsAPI(() => {
        setHasLoaded(true);
      }, (e) => {
        console.error(e);
      });
    }
  }, []);

  return (
    <>
      {hasLoaded ? (
        <>{children}</>
      ) : (
        <PlaceholderAddressDropdown
          LeadingIcon={<LocationIcon color={theme.themeColors.darkGreen1} />}
        />
      )}
    </>
  );
};

export default withTheme(MapsAPIWrapper);

MapsAPIWrapper.propTypes = {
  theme: PropTypes.shape({
    themeColors: PropTypes.shape({
      darkGreen1: PropTypes.string,
    }),
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
};
